import React, { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from './Modal';

const isValidUrl = (value) => {
  try {
    const { protocol } = new URL(value);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};

function NameUrlDialog({
  open,
  title,
  initialName = '',
  initialUrl = '',
  withUrl = false,
  submitLabel = 'Save',
  onSubmit,
  onClose,
}) {
  const [name, setName] = useState(initialName);
  const [url, setUrl] = useState(initialUrl);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setName(initialName);
      setUrl(initialUrl);
      setErrors({});
    }
  }, [open, initialName, initialUrl]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const trimmedName = name.trim();
    const trimmedUrl = url.trim();
    const nextErrors = {};
    if (!trimmedName) nextErrors.name = 'Name is required';
    if (withUrl && !isValidUrl(trimmedUrl)) {
      nextErrors.url = 'Enter a valid http(s) URL';
    }
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    onSubmit(
      withUrl ? { name: trimmedName, url: trimmedUrl } : { name: trimmedName }
    );
  };

  const inputClass = (hasError) =>
    `border-[#CBCBCB] border-[1px] px-2 py-2 rounded-lg focus:outline-none ${
      hasError ? 'border-red-600' : ''
    }`;

  return (
    <Modal modalOpen={open} onClose={onClose} title={title} small>
      <form className="text-gray-700 space-y-3" onSubmit={handleSubmit}>
        <div className="flex flex-col space-y-1">
          <label htmlFor="nameUrlDialogName" className="text-sm">
            Name
          </label>
          <input
            id="nameUrlDialogName"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={inputClass(errors.name)}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
          {errors.name && (
            <span className="text-red-600 text-xs">{errors.name}</span>
          )}
        </div>
        {withUrl && (
          <div className="flex flex-col space-y-1">
            <label htmlFor="nameUrlDialogUrl" className="text-sm">
              URL
            </label>
            <input
              id="nameUrlDialogUrl"
              type="url"
              value={url}
              placeholder="https://..."
              onChange={(e) => setUrl(e.target.value)}
              className={inputClass(errors.url)}
            />
            {errors.url && (
              <span className="text-red-600 text-xs">{errors.url}</span>
            )}
          </div>
        )}
        <div className="flex justify-between pt-4">
          <button
            className="border-[1px] border-claret-500 px-4 py-1 rounded-md text-claret-500 text-sm space-x-2 flex items-center"
            type="button"
            onClick={onClose}
          >
            <CancelIcon fontSize="inherit" />
            <p>Cancel</p>
          </button>
          <button
            className="bg-claret-500 px-4 py-1 rounded-md text-white text-sm space-x-2 flex items-center"
            type="submit"
          >
            <SaveIcon fontSize="inherit" />
            <p>{submitLabel}</p>
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default NameUrlDialog;
